// Wspólne formatowanie liczb i czasu dla wszystkich ekranów i linii (po polsku) - jedno miejsce, bez kopii w modułach.

/** Liczba z przecinkiem i stałą liczbą miejsc; null = „-”. */
export function liczba(v: number | null | undefined, miejsca: number): string {
  return v == null ? "-" : v.toLocaleString("pl-PL", { minimumFractionDigits: miejsca, maximumFractionDigits: miejsca });
}

/** Ilość bez zbędnych zer: 1 → „1”, 0,7 → „0,7”, 2,5 → „2,5” (do 3 miejsc). */
export function ilosc(v: number): string {
  return v.toLocaleString("pl-PL", { maximumFractionDigits: 3 });
}

/** Czas trwania: „1 h 5 min” / „7 h” / „45 min”; null = „-”. */
export function czas(sekundy: number | null | undefined): string {
  if (sekundy == null) return "-";
  const min = Math.floor(sekundy / 60);
  const h = Math.floor(min / 60);
  const m = min % 60;
  // Jak makieta (POROWNANIE.md 15.3): „7 h”, „6 h 42 min”, „45 min”.
  return h > 0 ? (m > 0 ? `${h} h ${m} min` : `${h} h`) : `${m} min`;
}

/** Licznik jak zegar: „0:12:05” (licznik fazy kolumny); null = „-”. */
export function zegar(sekundy: number | null | undefined): string {
  if (sekundy == null) return "-";
  const s = Math.max(0, Math.floor(sekundy));
  return `${Math.floor(s / 3600)}:${String(Math.floor(s / 60) % 60).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

/** Poziom koloru temperatury (KN-20, klasa `iot-kafel-temp--t<n>`): 0 = brak wartości, 1 = poniżej pierwszego progu albo kanał
 *  zimny (woda), dalej +1 za każdy przekroczony próg z opisu linii (`PROGI_KOLORU_<LINIA>`). */
export function poziomTemperatury(v: number | null | undefined, progi: readonly number[], zimny = false): number {
  if (v == null) return 0;
  return zimny ? 1 : 1 + progi.filter((p) => v >= p).length;
}

/** Sama data: „19.10.2026”. */
export function data(unixS: number): string {
  return new Date(unixS * 1000).toLocaleDateString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric" });
}

/** Pełna data z godziną: „19.10.2026, 14:05”. */
export function dataGodzina(unixS: number): string {
  return new Date(unixS * 1000).toLocaleString("pl-PL",
    { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

/** Godzina, gdy to dziś, inaczej „dd.mm, HH:MM” (napis się nie starzeje w ciągu dnia). */
export function godzinaLubData(unixS: number, teraz: Date = new Date()): string {
  const d = new Date(unixS * 1000);
  if (d.toDateString() === teraz.toDateString()) return d.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" });
  return dzienGodzina(unixS);
}

/** „dd.mm, HH:MM” zawsze z dniem (Start i Koniec zakończonego procesu). */
export function dzienGodzina(unixS: number): string {
  const d = new Date(unixS * 1000);
  return d.toLocaleDateString("pl-PL", { day: "2-digit", month: "2-digit" }) + ", "
    + d.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" });
}

/** „Liczba karty”: 1 karta, 2-4 karty, 5 kart (polska odmiana; `{n}` w tekstach). */
export function odmiana(n: number, jeden: string, kilka: string, wiele: string): string {
  const d = n % 10, s = n % 100;
  return n === 1 ? jeden : d >= 2 && d <= 4 && (s < 12 || s > 14) ? kilka : wiele;
}

/** Inicjały konta do awatara (APP i panel): dwa pierwsze słowa nazwy, bez nazwy - z e-maila. */
export function inicjaly(nazwa: string, email: string): string {
  const slowa = nazwa.trim().split(/[^\p{L}\d]+/u).filter(Boolean); // „Test - udostępnienia” → TU, nie „T-”
  const z = slowa.length >= 2 ? (slowa[0]![0] ?? "") + (slowa[1]![0] ?? "") : (slowa[0] ?? email.replace(/[^\p{L}\d]/gu, "")).slice(0, 2);
  return z.toUpperCase();
}
